import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/logo-design.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Logodesign() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Unique and Memorable",
            content: "We craft logos that stand out and resonate with your audience, leaving a lasting impression.",
        },
        {
            title: "Versatile",
            content: "Your logo will look great across various platforms, from business cards to social media profiles, with consistent visual appeal.",
        },
        {
            title: "Aligned with Your Brand",
            content: "We work closely with you to ensure your logo represents your mission, values, and market positioning.",
        },

    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Brand Logo Design",
            desc: "Create a unique and memorable logo that perfectly represents your brand’s identity and vision.",
        },
        {
            title: "Corporate Logo Design",
            desc: "Enhance your company’s image with a professional and timeless logo that builds trust and recognition.",
        },
        {
            title: "Custom Icon & Symbol Design",
            desc: "Tailored iconography and logo symbols crafted to suit your brand’s style and industry.",
        },
    ];


    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        AOS.init({
            duration: 1200, // fade duration for all (ms)
            easing: "ease-in-out", // smooth effect
            once: true,
        });
    }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Logo Design</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/logo">Logo Design </a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image" data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content" data-aos="fade-right">
                            <h1>Logo Design Services</h1>

                            <p>
                                Welcome to REDITE’s professional logo design services, where we transform your brand’s vision into a unique and impactful visual identity.
                            </p>

                            <h3>Crafting Logos That Speak for Your Brand</h3>


                            <p>
                                At REDITE, we believe that a logo is more than just a symbol—it’s the face of your brand. Our talented design team specializes in creating logos that are visually captivating, aligning perfectly with your brand’s identity and core values. We understand the power of first impressions, and our logos are designed to make sure yours is unforgettable. </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>Tailored for Every Business</h3>

                            <p>
                                Whether you’re a startup eager to establish a bold presence or a seasoned business seeking a fresh, modern look, REDITE is here to help. Our logo design process is rooted in creativity and innovation, ensuring that each logo we deliver is:
                            </p>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>LOGO DESIGN WE OFFER</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Process: Designed for Your Success</h4>
                        <p>
                            Our logo design journey begins with understanding your brand’s personality, target audience, and vision. From initial sketches to final touches, we ensure every detail reflects your brand’s essence. We prioritize open communication, making you a part of each stage—from conceptualization to revisions—so the final result is truly a collaborative masterpiece.
                        </p>

                        <h4>Why Choose REDITE for Your Logo Design?</h4>
                        <p>
                          With years of experience and a passion for branding, REDITE combines artistic expertise with strategic thinking. Our approach to logo design is thorough, innovative, and focused on delivering a product that stands the test of time.
                        </p>

                        <p>
                            Ready to bring your brand to life with a custom-designed logo? 
                            <span>  Let REDITE design a logo that captures your brand’s soul and resonates with your audience.</span>Contact us today to get started!
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Logodesign;
